import { generateUuid } from '@pkg/shared/utils/id.utils'

const TAB_ID_KEY = 'app:sync:tabId'

export function getTabId(): string {
  if (typeof sessionStorage === 'undefined') return 'unknown'
  const existing = sessionStorage.getItem(TAB_ID_KEY)
  if (existing) return existing

  const id = generateUuid()
  sessionStorage.setItem(TAB_ID_KEY, id)
  return id
}
